import {ThemeProvider} from '@providers/ThemeProvider';
import {AuthProvider} from '@providers/AuthProvider';
import {GqlProvider} from '@providers/GqlProvider';
import {ConsentContextProvider} from '@providers/ConsentContextProvider';
import {LogEventProvider} from '@providers/LogEventProvider';
import {ImportStateProvider} from '@providers/ImportStateProvider';

import {Layout} from '@components/Layout';

export const AppRoot = ({children}: {children?: React.ReactNode}) => (
	<AuthProvider>
		<GqlProvider>
			<ThemeProvider>
				<ConsentContextProvider>
					<LogEventProvider>
						<ImportStateProvider>
							<Layout>{children}</Layout>
						</ImportStateProvider>
					</LogEventProvider>
				</ConsentContextProvider>
			</ThemeProvider>
		</GqlProvider>
	</AuthProvider>
);
